import { EStorageType } from 'reactApp/modules/storage/storage.types';

export const isHomeLikeStorage = (storage: EStorageType): boolean => {
    return (
        storage === EStorageType.home ||
        storage === EStorageType.familyFolders ||
        storage === EStorageType.familyAlbums ||
        storage === EStorageType.gallery ||
        storage === EStorageType.albums ||
        storage === EStorageType.documents ||
        storage === EStorageType.feed
    );
};
